<script lang="ts">
  import type { ItemExtraStats } from '../../items';

  export let stats: ItemExtraStats;
</script>

{#if stats.armor > 0}
  <p>+{stats.armor.toFixed(0)} armor</p>
{/if}

{#if stats.damage > 0}
  <p>+{stats.damage.toFixed(0)} damage</p>
{/if}

{#if stats.moveSpeed > 0}
  <p>+{(stats.moveSpeed * 100).toFixed(0)}% movement speed</p>
{/if}

{#if stats.attackSpeed > 0}
  <p>+{stats.attackSpeed.toFixed(0)}% attack speed</p>
{/if}

{#if stats.health > 0}
  <p>+{stats.health.toFixed(0)} health</p>
{/if}
